<template>
  <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-8">
    <div class="col-span-6 flex flex-col gap-y-8 laptop:col-span-5 laptop:gap-y-10">
      <h2>{{ data?.companyPage?.data?.attributes?.whoweare_title }}</h2>
      <div
        class="space-y-8 laptop:space-y-10"
        v-html="marked.parse(data?.companyPage?.data?.attributes?.Whoweare_paragraphs || '')"
      ></div>
      <ImageStrapi class="w-full laptop:-mt-[9px]" :img="data?.companyPage?.data?.attributes?.whoweare_largeImage" />
    </div>
    <ImageStrapi
      class="relative col-span-6 mt-8 h-auto w-full laptop:top-[60%] laptop:col-span-3 laptop:mt-0 laptop:-mt-9 desktop:top-[40%]"
      :img="data?.companyPage?.data?.attributes?.whoweare_smallImage"
    />
  </div>
</template>
<script setup>
import { Companypage2DataKey } from "~/symbols/symbols";
import { marked } from "marked";

const data = inject(Companypage2DataKey);
</script>
<style lang="scss" scoped></style>
